// extracted by mini-css-extract-plugin
module.exports = {"detailsTextBold":"ClientTools_detailsTextBold__1fQNN"};